const SITE_URL = 'https://situsai.ca';

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Situs Canada",
  url: SITE_URL,
  logo: `${SITE_URL}/logo.svg`,
  description: "Orca is an AI workbench for Canadian CPA firms, focused on workspace documents, authoritative Canadian tax citations, source previews, and reviewable drafts.",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Montreal",
    addressRegion: "QC",
    addressCountry: "CA"
  },
  contactPoint: {
    "@type": "ContactPoint",
    email: "carlo@situsai.ca",
    contactType: "customer service",
    areaServed: "CA"
  }
};

export const softwareAppSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "Orca",
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web",
  offers: {
    "@type": "Offer",
    price: "49.00",
    priceCurrency: "CAD",
    description: "Professional access for the Canadian CPA workbench"
  },
  description: "AI workbench for Canadian CPA firms. Prepare CRA reassessment response drafts from workspace documents and authoritative Canadian tax sources with citations and review gates."
};

export function createBreadcrumbSchema(path: string) {
  const routes: Record<string, string> = {
    '/cra-reassessment-response': 'CRA Reassessment Response',
    '/pricing': 'Pricing',
    '/security': 'Security',
    '/about': 'About Us',
    '/contact': 'Contact',
    '/privacy': 'Privacy Policy',
    '/terms': 'Terms of Service',
    '/subprocessors': 'Sub-processors',
    '/vulnerability-disclosure': 'Vulnerability Disclosure',
  };

  const crumbs = [{ name: 'Home', url: SITE_URL }];

  if (path !== '/' && routes[path]) {
    crumbs.push({ name: routes[path], url: `${SITE_URL}${path}` });
  }

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map((crumb, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: crumb.name,
      item: crumb.url
    }))
  };
}

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Situs Canada",
  url: SITE_URL,
  description: "Orca is an AI workbench for Canadian CPA firms with client workspace docs, authoritative Canadian tax citations, source previews, and reviewable drafts."
};

export const accountingServiceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Orca - Canadian CPA Workbench",
  description: "Canadian CPA workbench for CRA reassessment response workflows, workspace documents, authoritative tax citations, source previews, and reviewable drafts.",
  provider: {
    "@type": "Organization",
    name: "Situs Canada",
    url: SITE_URL
  },
  areaServed: "CA",
  serviceType: "Canadian CPA Workbench",
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Orca Plans",
    itemListElement: [
      {
        "@type": "Offer",
        name: "Professional",
        price: "49.00",
        priceCurrency: "CAD",
        priceValidUntil: "2026-12-31",
        offers: {
          "@type": "Offer",
          url: `${SITE_URL}/pricing`,
          availability: "https://schema.org/InStock",
          availabilityStarts: "T00:00:00-05:00",
          availabilityEnds: "T23:59:59-05:00"
        }
      }
    ]
  }
};

export function createFAQSchema(faqs: { question: string; answer: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map(faq => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer
      }
    }))
  };
}
